import { starRatingWidgetParser } from "@redotech/redo-review-db-schema/star-rating-widget-schema";
import * as z from "zod";

export const getOrCreateStarRatingWidget = {
  name: "getOrCreateStarRatingWidget" as const,
  input: z.object({ teamId: z.string() }),
  output: starRatingWidgetParser,
};
